import React, { forwardRef, useEffect, useRef } from "react";
import { Alert, Icon } from "@citi-icg-172888/icgds-react";

interface CustomAlertProps {
  errors: any;
  page?: string;
  id?: string;
  handleChange?: () => any;
  isSubmitClicked?: boolean;
}

const CustomAlert = forwardRef<HTMLDivElement, CustomAlertProps>(({ errors, page, id, handleChange, isSubmitClicked }, ref) => {
  const localRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const currentRef = ref || localRef;
    if (currentRef && 'current' in currentRef && currentRef.current) {
      currentRef.current.focus();
    }
  }, [isSubmitClicked]);

  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div id={id} ref={ref || localRef} tabIndex={-1}>
      <Alert
        style={{ boxShadow: "0px 5px 10px 1px" }}
        className="icgds lmn-alert lmn-alert-danger"
        type="warning"
        showIcon
        closable
        onClose={() => handleChange && handleChange()}
        customizeIcon={<Icon type="alert-triangle" style={{ color: "black" }} alt="Error icon indicating an issue" aria-label="Error icon indicating an issue" />} // Customize the icon color
      >
        {page === "BusinessNeedsPage"
          ? "Select at least one option. Then, add a description between 80 and 1,000 characters."
          : "Please provide the missing information. Fields with errors are marked with an asterisk (*) and described below."}
      </Alert>
    </div>
  );
});

export default CustomAlert;